<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Manage Payment Method</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full" v-if="billingData">
                    <div class="w-full md:w-1/2 md:pr-4">
                        <div class="account-body">
                            <h2>Current Payment Method</h2>

                            <div class="form-field">
                                <label>Provider</label>
                                <input type="text" readonly="readonly" class="form-field inline no-transform" :value="billingData.provider">
                            </div>

                            <div class="form-field">
                                <label>Identifier</label>
                                <input type="text" readonly="readonly" class="form-field inline no-transform" :value="billingData.identifier">
                            </div>

                            <div class="form-field">
                                <label>Friendly Name</label>
                                <input type="text" readonly="readonly" class="form-field inline no-transform" :value="billingData.friendly_name">
                            </div>

                            <div class="form-field">
                                <button class="btn-danger muted" type="button" @click="handleCancelPayment" v-if="billingData.identifier">Cancel Payment Method</button>
                            </div>
                        </div>
                    </div>

                    <div class="w-full md:w-1/2 md:pl-4">
                        <div class="account-body">
                            <h2>New Payment Method</h2>

                            <card-payment
                                :amount="parseFloat(0)"
                                :stripeKey="stripeKey"
                                :saved="[]"
                                text="Update Payment Details"
                                title="New Card Details"
                                @submit="handleUpdatePayment"
                            ></card-payment>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CardPayment from '../../CardPayment'

    export default {
        name: 'PaymentMethodView',
        components: {
            CardPayment,
        },
        data() {
            return {
                stripeKey: null,
                billingData: null,
            }
        },
        mounted() {
            this.loadData()
            this.setMetaTitle('Manage Payment Method | JournoLink Control')

            this.stripeKey = document.querySelector('meta[name="stripe-key"]').getAttribute('content')
        },
        beforeDestroy() {
            //
        },
        watch: {
            //
        },
        computed: {
            //
        },
        methods: {
            loadData () {
                this.billingData = {
                    provider: null,
                    identifier: null,
                    friendly_name: null,
                }

                axios.get(route('accounts.show', this.$route.params.accountId))
                    .then(response => {
                        if (!response.data.account.subscription ||
                            !response.data.account.subscription.order ||
                            !response.data.account.subscription.order.order_billing
                        ) {
                            return
                        }

                        var billData = response.data.account.subscription.order.order_billing
                        this.billingData = {
                            identifier: billData.recurring_token,
                            friendly_name: billData.friendly_name,
                        }

                        if (billData.provider) {
                            this.billingData.provider = billData.provider.name || ''
                        }
                    })
                    .catch(e => {
                        console.error({e})
                    })
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView() {
                this.$root.goBack()
            },
            /**
             * Handle a button press to cancel the users current payment method
             *
             * @return {void}
             */
            handleCancelPayment() {
                this.alert.fire({
                    title: 'Are you sure?',
                    text: 'Are you sure you want to cancel this users payment method? They will not be able to make further payments or renew their subscription until new details have been provided.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, continue',
                    confirmButtonColor: '#E3342F',
                    cancelButtonText: 'No, go back'
                })
                .then((selected) => {
                    if(selected.value){
                        axios.delete(
                            route('subscriptions.payment-method.destroy', this.$route.params.accountId))
                            .then(response => {
                                this.$bus.$emit('account.reload')
                                this.$bus.$emit('alert.success', 'Account payment method has been cancelled')
                                this.closeView()
                            })
                            .catch(e => {
                                // Did we receive a validation response?
                                if (e.response && e.response.status === 422) {
                                    if (e.response.data.errors.paymentToken) {
                                        let error = e.response.data.errors.paymentToken.shift()
                                        this.$bus.$emit('alert.danger', error)

                                        return
                                    }
                                }

                                this.$bus.$emit('alert.danger', 'There was an error in processing the change')
                            })
                    }
                })
            },
            /**
             * Handle an updated payment method token and save
             *
             * @param  {String} token
             * @return {void}
             */
            handleUpdatePayment(token) {
                axios.post(
                    route('subscriptions.payment-method', this.$route.params.accountId), {
                        paymentToken: token.id,
                    })
                    .then(response => {
                        this.$bus.$emit('account.reload')
                        this.$bus.$emit('alert.success', 'Account payment method has been updated')
                        this.closeView()
                    })
                    .catch(e => {
                        // Did we receive a validation response?
                        if (e.response.status === 422) {
                            if (e.response.data.errors.paymentToken) {
                                let error = e.response.data.errors.paymentToken.shift()
                                this.$bus.$emit('alert.danger', error)

                                return
                            }
                        }

                        this.$bus.$emit('alert.danger', 'There was an error in processing the change')
                    })
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
        }
    }
</script>

<style lang="less" scoped>
    .modal-body {
        h2, h3 {
            text-transform: uppercase;
            font-size: 1.2em;
            letter-spacing: .08em;
            color: #34495e;
            margin-bottom: 10px;
        }
    }

    p.note {
        margin: 10px 0;
        font-weight: bold;
    }
</style>
